import { nanoid } from 'nanoid';
import { Platform } from 'react-native';

export type Partial<T> = {
  [key in keyof T]?: T[key];
};

export type TTypeOption = 'ticket' | 'schedule' | 'option';

export interface ITicketDetails {
  calendar_id: string;
  price: null | string;
  strike_out: null | string;
  wholesale: null | string;
  commission: null | string;
  min: null | string;
  //total: null | string;
  total_ts: null | string;
  disable_promos: null | string;
  is_disabled: null | string;
  //is_disabled_ts: null | string;
  sold: null | string;
  sold_ts: null | string;
}

export interface IOtionDetailsValue {
  id: string;
  price: null | string;
  is_disabled: null | string;
  apply_tax: null | string;
}

export interface IOptionDetails {
  calendar_id: string;
  is_disabled: string | null;
  values: IOtionDetailsValue[];
}

export interface IOptionsDetailsData {
  [date: string]: IOptionDetails;
}

export interface ITicketsDetailsData {
  [schedule_id: string]: {
    [date: string]: ITicketDetails;
  };
}

export interface IScheduleDetails {
  calendar_id: string;
  min_tickets: null | string;
  max_tickets: null | string;
  is_disabled: null | string;
  sold: null | string;
}

export interface ISchedulesDetailsData {
  [schedule_id: string]: {
    [date: string]: IScheduleDetails;
  };
}

export interface IStateOption {
  partner_id?: number;
  trip_id?: number;
  rate_id?: number;
  type?: string;
  schedulesIds?: number[];
  option_type?: number;
  ticket_type?: number;
}
export interface ICalendarDate {
  id: string;
  date_from?: null | string;
  date_to?: null | string;
}

export interface IState {
  options: IStateOption;
  tripData?: ITripCalendarData;
  dates: ICalendarDate[];
  week?: number[];
  detailsData?: any;
}

export const initialState: IState = {
  options: {},
  dates: [
    {
      id: nanoid(8),
    },
  ],
};

export interface ITripCalendarData {
  is_integrated: 0 | 1;
  name: string;
  tickets: {
    id: number;
    is_disabled_ts: 0 | 1;
    min: number;
    name: string;
    price: number;
    strike_out: number;
    total_ts: number;
    wholesale: number;
    view_order: number;
  }[];
  additional_options: {
    id: number;
    is_disabled: 0 | 1 | null;
    name: string;
    required: 0 | 1;
    type: 'text' | 'select';
    values: {
      id: number;
      apply_tax: 0 | 1;
      is_disabled: 0 | 1 | null;
      name: string;
      price: number;
    }[];
  }[];
  valid_from: string | null;
  valid_to: string | null;
  weekly: string;
  use_schedule: 0 | 1;
  use_rates: 0 | 1;
  schedules: {
    id: number;
    is_disabled: 0 | 1;
    max_tickets: number | null;
    min_tickets: number | null;
    hour: number;
    minute: number;
  }[];
  //inventories: ITripEquipmentReceived[];
  rates: {
    id: number;
    trip_id: number;
    name: string;
    disabled: number;
  }[];
}
